export default "__VITE_ASSET__1m5Idmgf__"